import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IBillingDetailsResponse } from "./index.type";

const useGetBillingDetails = ({ billingId }: { billingId?: string }) => {
  const [reportBillingDetails, setReportBillingDetails] =
    React.useState<IBillingDetailsResponse>();

  const { loading: getAllDetailsLoading, makeApiCall } = useApi({
    method: "GET",
    url: `/rtm/patient-dashboard/pdf/v3/billing-details/${billingId}`,
  });

  const getBillingDetails = async () => {
    if (!billingId) return;

    const { response, error } = await makeApiCall<
      undefined,
      IBillingDetailsResponse
    >();

    if (response) {
      setReportBillingDetails(response);
    } else if (error) {
      toast.error(error.msg);
      setReportBillingDetails(undefined);
    }
  };

  return { getBillingDetails, reportBillingDetails, getAllDetailsLoading };
};

export default useGetBillingDetails;
